import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import { ReactComponent as OnlineIcon } from "../../../../assets/OnlineIcon.svg";
import { ReactComponent as OfflineIcon } from "../../../../assets/OfflineIcon.svg";
import { offlineSelector } from "../../../../redux/metadata/selectors/metadata.selectors";
import OfflineStorage from "../../../../common/offlineStorage/OfflineStorage";
import colors from "common/styles/colors";

const Container = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  min-width: 40px;

  span {
    color: ${colors.red[800]};
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    margin-left: 6px;
  }
`;

export const FreyaOnlineStatusIndicator = () => {
  const [outOfSyncBadgesCount, setOutOfSyncBadgesCount] = useState(0);
  const isOffline = useSelector(offlineSelector);

  useEffect(() => {
    OfflineStorage.getOutOfSyncBadgesCount()
      .then(setOutOfSyncBadgesCount)
      .catch(() => setOutOfSyncBadgesCount(0));
  }, [isOffline]);

  return (
    <Container>
      {isOffline ? (
        <>
          <OfflineIcon data-testid="offline-icon" />

          <span>{outOfSyncBadgesCount}</span>
        </>
      ) : (
        <OnlineIcon data-testid="online-icon" />
      )}
    </Container>
  );
};
